import { json } from '@remix-run/node'
import { useLoaderData } from '@remix-run/react'
import { H5 } from '#app/components/typography/h5.tsx'
import { readSource } from '../sections/sections.server.tsx'
import { Description, Features, Source, type componentProps, Parts, Usage, Styling } from '../sections/sections.tsx'

export const handle = {
	breadcrumb: 'H5',
}

const component: componentProps = {
	name: 'H5',
	shortName: 'H5',
	fileName: 'h5',
	category: 'typography',
	description: ['H5 heading component.'],
	features: ['Drop-in replacement for the native <h5> element.', "Opts-in to your design system's typographic styles."],
	parts: [],
	usage: `<H5>This is an h5 heading</H5>`,
	styling: `.h5 {
	@apply text-muted-900 text-fluid-lg max-w-prose font-sans font-bold;
}`,
}

export const loader = async () => {
	const source = await readSource({ category: component.category, fileName: component.fileName })
	return json({ source })
}

const HeadingRoute = () => {
	const { source } = useLoaderData<typeof loader>()
	const { name, description, shortName, fileName, features, usage, parts, styling } = component

	return (
		<>
			<Description name={name} description={description} />
			<Usage usage={usage} shortName={shortName} />
			<H5>This is an h5 heading</H5>
			<Features features={features} />
			<Parts parts={parts} />
			<Source source={source} fileName={fileName} />
			<Styling styling={styling} />
		</>
	)
}
export default HeadingRoute
